<template>
    <div class="resume">
        <div class="apply-now">
            <v-container>
                <div class="btn-apply-now">
                    <v-btn color="#7ec352" v-ripple role="button" @click="advanceApplynome = !advanceApplynome">
                        {{oracle.translate('همین حالا اقدام کن')}}
                    </v-btn>
                </div>
                <div v-if="advanceApplynome">
                    <v-container>
                        <div class="content-apply-now">
                            <div class="section-apply-now">
                                <v-row>
                                    <v-col cols="3">
                                        <div class="f-section-description">
                                            <div class="description-apply-now">
                                                <h3>{{oracle.translate('اطلاعات شخصی')}}</h3>
                                                <p>{{oracle.translate('اطلاعاتی را در مورد خودتان وارد نمائید')}}</p>
                                            </div>
                                            <div class="description-apply-now">
                                                <h3>{{oracle.translate('رزومه')}}<span>*</span></h3>
                                                <p>{{oracle.translate('فایل رزومه خود را بارگذاری نمائید')}}</p>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="9">
                                        <div class="field-apply-now">
                                            <p>{{oracle.translate('نام و نام خانوادگی')}}<span>*</span></p>
                                            <v-text-field
                                                    dir="auto"
                                                    solo
                                                    hide-details
                                                    :label="oracle.translate('نام و نام خانوادگی')"
                                                    v-model="name"
                                            >
                                            </v-text-field>
                                        </div>
                                        <div class="field-apply-now">
                                            <p>{{oracle.translate('پست الکترونیک')}}<span>*</span></p>
                                            <v-text-field
                                                    dir="auto"
                                                    solo
                                                    hide-details
                                                    :label="oracle.translate('پست الکترونیک')"
                                                    v-model="email"
                                            ></v-text-field>
                                        </div>
                                        <div class="field-apply-now">
                                            <p>{{oracle.translate('شماره موبایل')}}<span>*</span></p>
                                            <v-text-field
                                                    dir="auto"
                                                    solo
                                                    hide-details
                                                    :label="oracle.translate('شماره موبایل')"
                                                    v-model="phone"
                                            ></v-text-field>
                                        </div>

                                        <div class="field-apply-now-photo">
                                            <form class="box-upload">
                                                <input type="file" id="myFile" name="filename"/>
                                            </form>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="section-apply-now">
                                <v-row>
                                    <v-col cols="3">
                                        <div class="f-section-description">
                                            <div class="description-apply-now">
                                                <h3>{{oracle.translate('موارد بیشتر')}}</h3>
                                                <p>{{oracle.translate('جزئیات بیشتری را در مورد خودتان وارد کنید')}}</p>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="9">
                                        <div class="field-apply-now-text">
                                            <p>{{oracle.translate('توضیحات')}}</p>
                                            <v-textarea
                                                    dir="auto"
                                                    solo
                                                    hide-details
                                                    :label="oracle.translate('توضیحات')"
                                                    style="text-align: right"
                                                    v-model="letter"
                                            >
                                            </v-textarea>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="section-apply-now">
                                <v-row>
                                    <v-col cols="3">
                                        <div class="f-section-description">
                                            <div class="description-apply-now">
                                                <h3>{{oracle.translate('سوالات')}}</h3>
                                                <p>{{oracle.translate('لطفا سوالات اضافی را پر کنید')}}</p>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="9">
                                        <div class="field-apply-now col-md-12 col-lg-9 col-12">
                                            <p>{{oracle.translate('آخرین کارفرما')}}</p>
                                            <v-text-field
                                                    solo
                                                    hide-details
                                                    :label="oracle.translate('آخرین کارفرما')"
                                                    v-model="job_title"
                                            >
                                            </v-text-field>
                                        </div>
                                        <div class="field-apply-now col-md-12 col-lg-9 col-12">
                                            <p>{{oracle.translate('عنوان شغلی فعلی')}}</p>
                                            <v-text-field
                                                    solo
                                                    hide-details
                                                    :label="oracle.translate('عنوان شغلی فعلی')"
                                                    v-model="job_status"
                                            >
                                            </v-text-field>
                                        </div>
                                        <div class="field-apply-now col-md-12  col-lg-9 col-12">
                                            <p>{{oracle.translate('وضعیت شغلی')}}</p>
                                            <v-text-field
                                                    :items="select"
                                                    solo
                                                    :label="oracle.translate('وضعیت شغلی')"
                                                    v-model="current_job"
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                            <div class="end-section col-md-12 col-lg-12 col-12">
                                <v-container fluid>
                                    <v-checkbox
                                            v-model="ex4"
                                            :label="oracle.translate('این وب سایت می تواند از اطلاعاتی که من داده ام استفاده کند تا مرا برای این سمت در نظر بگیرد.')"
                                            color="red"
                                            value="red"
                                            style="margin-bottom: 13px"
                                            hide-details
                                    ></v-checkbox>
                                </v-container>
                            </div>
                        </div>
                    </v-container>
                    <div class="btn-submit">
                        <v-btn color="#7ec352">
                            {{oracle.translate('ثبت درخواست')}}
                        </v-btn>
                    </div>
                </div>
            </v-container>
        </div>
        <v-dialog
                v-model="dialogPre"
                class="WarningModal"
                justify="center"
                width="500"
        >
            <v-card class="content-Modal resume">
                <v-card-text class="contentModal">
                    {{oracle.translate('با تشکر از ثبت اطلاعات , همکاران پشتیبانی با شما تماس خواهند گرفت')}}
                </v-card-text>

                <v-card-actions class="btnsModal">
                    <v-btn color=" darken-1" text v-ripple role="button" @click="dialogPre = false">
                        {{oracle.translate('بازگشت')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import oracle from "../oracle";

    export default {
        name: "resume",
      computed: {
        oracle() {
          return oracle
        }
      },
        data() {
            return {
                ex4: ["red"],
                advanceApplynome: false,
                dialogPre: false,
                name: "",
                email: "",
                phone: "",
                letter: "",
                job_title: "",
                job_status: "",
                current_job: "",
            };
        },

        created() {
            document.title = oracle.translate("رزومه");
        },
    };
</script>
<style>
    .resume .list-items {
        list-style: disc;
    }

    .resume .apply-now {
        width: 100%;
        background: #eee;
        height: auto;
        z-index: 1;
        position: relative;
        padding: 5em 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
    }

    .resume .btn-apply-now button {
        color: #fff !important;
        height: 70px !important;
        background: #7ec352;
        width: 15%;
        border-radius: 5px;
        position: relative;
        top: -40px;
        font-size: 14px;
    }

    .resume .btn-apply-now {
        display: flex;
        justify-content: flex-start;
    }

    .resume .content-apply-now {
        background: #fff;
        height: auto;
    }

    .resume .field-apply-now {
        margin: 2.5em 15px;
        padding: 5px;
        height: 50px;
    }

    .resume .field-apply-now-text {
        margin: 2.5em 15px;
        padding: 5px;
    }

    .resume .field-apply-now .v-text-field label,
    .resume .field-apply-now .v-select label,
    .resume .field-apply-now-text .v-textarea label {
        color: #001e60 !important;
        font-size: 12px;
    }

    .resume .field-apply-now .v-btn {
        width: 100%;
        margin-top: 3em;
    }

    .resume .field-apply-now-text .v-textarea {
        background: #fff;
    }

    .resume .field-apply-now .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot,
    .resume .field-apply-now-text .v-input__control,
    .resume .field-apply-now-photo {
        box-shadow: none;
        border: 1px solid #707070;
        box-shadow: none !important;
    }

    .resume .field-apply-now p,
    .resume .field-apply-now-text p {
        font-size: 11px;
        font-weight: bold;
        color: #001e60;
        margin-bottom: 0;
        padding: 10px 0;
    }

    .resume .field-apply-now span {
        color: #ca8d45;
        font-size: 20px;
    }

    .resume .field-apply-now-photo {
        border-radius: 5px;
        margin: 4.5em 20px;
        padding: 5px;
        height: 50px;
    }

    .resume .box-upload {
        padding: 5px;
    }

    .resume .f-section-description {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 3.5em 25px;
        height: 70%;
    }

    .resume .description-apply-now {
        color: #001e60;
    }

    .resume .description-apply-now p {
        margin-bottom: 0;
        font-size: 13px;
        padding: 10px 0;
    }

    .resume .description-apply-now span {
        color: #7ec352;
    }

    .resume .description-apply-now h3 {
        font-size: 17px;
    }

    .resume .section-apply-now {
        border-bottom: 1px solid #707070;
    }

    .resume .btn-submit button {
        background: #7ec352 !important;
        color: #fff !important;
        height: 70px !important;
        width: 15%;
        border-radius: 5px;
    }

    .resume .btn-submit {
        display: flex;
        justify-content: flex-end;
    }

    .resume .end-section .v-input__slot label {
        font-size: 12px;
    }

    /*@media only screen and (max-width: 480px) {*/
    /*    .resume .btn-apply-now button,*/
    /*    .resume .btn-submit button {*/
    /*        width: 200px;*/
    /*    }*/
    /*}*/
</style>
